import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { StatsCard } from '../../../../models/stats-card';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import dayjs from 'dayjs';

@Component({
  selector: 'jhi-counters-stats-line',
  templateUrl: './counters-stats-line.component.html',
  styleUrls: ['./counters-stats-line.component.scss'],
})
export class CountersStatsLineComponent implements OnChanges {
  @Input() billDate: boolean = false;
  @Input() firstCard!: StatsCard | undefined;
  @Input() secondCard!: StatsCard | undefined;
  @Input() thirdCard!: StatsCard | undefined;
  @Input() title!: string;
  @Input() countersList!: string[];

  @Output() firstCounterChange = new EventEmitter<string>();
  @Output() secondCounterChange = new EventEmitter<string>();
  @Output() thirdCounterChange = new EventEmitter<string>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  firstSelect!: string;
  secondSelect!: string;
  thirdSelect!: string;
  setOfCards: StatsCard[] = [];

  ngOnChanges(changes: SimpleChanges) {
    for (const change in changes) {
      if (change === 'firstCard' && changes['firstCard']) {
        this.firstSelect = changes['firstCard'].currentValue.key;
        this.setOfCards.splice(0, 1, changes['firstCard'].currentValue);
      }
      if (change === 'secondCard' && changes['secondCard']) {
        this.secondSelect = changes['secondCard'].currentValue.key;
        this.setOfCards.splice(1, 1, changes['secondCard'].currentValue);
      }
      if (change === 'thirdCard' && changes['thirdCard']) {
        this.thirdSelect = changes['thirdCard'].currentValue.key;
        this.setOfCards.splice(2, 1, changes['thirdCard'].currentValue);
      }
    }
  }

  showCountersWithList(): void {
    this.firstCounterChange.emit(this.firstSelect);
    this.secondCounterChange.emit(this.secondSelect);
    this.thirdCounterChange.emit(this.thirdSelect);
  }

  setCounterLabel(counter: string): string {
    return 'baryApp.customer-statistics.counters.' + counter + (!this.billDate && counter === 'turnoverBilled' ? '.addLabel' : '.label');
  }

  setCounterPrecision(precision: number): string {
    return '1.' + precision + '-' + precision;
  }

  protected readonly dayjs = dayjs;
}
